import { HistoryEntry } from 'types';

export const historyTypes = {
  labelPrint: 'SHIPPING_LABEL_PRINTED',
};

export const SHAPE_HISTORY_ENTRY: HistoryEntry = {
  consignmentStatus: '',
  date: new Date(),
  description: '',
  employeeName: '',
  observation: '',
  posDisplayName: '',
  posName: '',
  type: '',
  attachments: [],
};

export const returnHistory: {
  [key: string]: {
    value: string;
  };
} = {
  CREATED: {
    value: 'Devolução criada por [employeeName]',
  },
  CREATED_WEB: {
    value: 'Devolução criada',
  },
  POST_CODE_GENERATED: {
    value: 'Código de postagem gerado por [employeeName]',
  },
  POST_CODE_GENERATED_WEB: {
    value: 'Código de postagem gerado',
  },
  POST_CODE_REVALIDATED: {
    value: 'Código de postagem revalidado por [employeeName]',
  },
  RECEIVED_CONFIRMED: {
    value: 'Devolução confirmada por [employeeName]',
  },
  INCONSISTENCY_CONFIRMED: {
    value: 'Inconsistência confirmada por [employeeName]',
  },
  REFUNDED: {
    value: 'Devolução estornada',
  },
  CANCELED: {
    value: 'Devolução cancelada',
  },
};

export const consignmentHistory: {
  [key: string]: {
    value: string;
  };
} = {
  CONSIGNMENT_CREATED: {
    value: 'Pedido realizado',
  },
  FRAUD_CHECK_OK: {
    value: 'Aprovado pelo antifraude',
  },
  WAITING_FOR_NEXT_OPENING_TIME: {
    value: 'Aguardando horário comercial para disponibilizar o pedido',
  },
  AVAILABLE_TO_STORE: {
    value: 'Disponibilizado para loja [posName] - [posDisplayName]',
  },
  RESERVED_BY_STORE: {
    value:
      'Atendimento iniciado por [employeeName] na loja [posName] - [posDisplayName]',
  },
  REVOKED_BY_STORE: {
    value:
      'Atendimento recusado por [employeeName] na loja [posName] - [posDisplayName]: [observation]',
  },
  SHIPPING_LABEL_PRINTED: {
    value: 'Etiqueta de transporte impressa por [employeeName]',
  },
  CONFIRMED_BY_STORE: {
    value: 'Pedido confirmado por [employeeName]',
  },
  INVOICED: {
    value: 'Pedido faturado',
  },
  CUSTOMER_PICKED_UP: {
    value: 'Retirada registrada por [employeeName] para [observation]',
  },
  START_SEND_TO_DELIVERY_COMPANY: {
    value: 'Solicitando coleta ao transportador',
  },
  SUCCESS_SEND_TO_DELIVERY_COMPANY: {
    value: 'Dados do pedido e coleta transmitidos ao transportador',
  },
  COLLECTED_BY_DRIVER: {
    value: 'Coleta registrada por [employeeName] para [observation]	',
  },
  CUSTOMER_PICKED_UP_STORE_SHIPPING: {
    value:
      'Retirada de um pedido de Entrega pela Loja registrada por [employeeName] para a cliente [observation]',
  },
  CANCEL_SHIPMENT_ORDER: {
    value: 'Solicitação de coleta cancelada no transportador',
  },
  PICKUP_BY_DRIVER: {
    value: 'Pedido retirado pelo transportador',
  },
  CLARIFY_DELIVERY_FAIL: {
    value: 'Problema na entrega',
  },
  COLLECT_FAIL: {
    value: 'Problema na coleta',
  },
  DELIVERY_FAIL_BY_DRIVER: {
    value: 'Falha na entrega, motorista retornou a remessa para a loja',
  },
  RESENT_TO_DELIVERY_COMPANY: {
    value: 'Pedido reenviado para o transportador por [employeeName]',
  },
  DELIVERED_BY_DRIVER: {
    value: 'Pedido Entregue',
  },
  ORDER_WAS_DELIVERED: {
    value: 'Pedido Entregue',
  },
  CHANGED_TO_ECOMMERCE: {
    value: 'Pedido mudado para o ecommerce',
  },
  CANCELLED: {
    value: 'Cancelado',
  },
  CONFIRMED_DELIVERY: {
    value: 'Pedido Entregue',
  },
  CONSIGNMENT_ATTENDANCE_WAS_RESTARTED_BY_STORE: {
    value: 'Atendimento reiniciado por [observation]',
  },
  FRAUD_NEED_CHECK: {
    value: 'Aguardando aprovação de antifraude',
  },
  RETURNED_TO_STORE: {
    value: 'Pedido retornado a loja: [posName], [posDisplayName]',
  },
  RETURNED_TO_STORES: {
    value: 'Pedido retornado as lojas',
  },
  SHIPPED: {
    value: 'Enviado',
  },
  SS_ORDER_CONFIRMED_EMAIL_SEND: {
    value: 'Notificação de pedido confirmado enviada',
  },
  SS_ORDER_CANCELLED_EMAIL_SEND: {
    value: 'Notificação de pedido cancelado enviada',
  },
  SS_ORDER_DELIVERED_EMAIL_SEND: {
    value: 'Notificação de pedido entregue enviada',
  },
  SS_ORDER_NOT_COLLECTED_EMAIL_SEND: {
    value: 'Notificação de pedido não-coletado enviada',
  },
  SS_ORDER_CHANGED_TO_ECOMMERCE_EMAIL_SEND: {
    value: 'Notificação de pedido revertido para o e-commerce enviada',
  },
  AVAILABLE_TO_STORES: {
    value: 'Pedido está disponível para as lojas',
  },
  CANCELLED_BY_ADMIN: {
    value: 'Cancelado manualmente por [employeeName]: [observation]',
  },
  CHANGE_DELIVERY_MODE: {
    value: 'Alterado tipo do frete do pedido',
  },
  CONFIRMED_PAYMENT: {
    value: 'Remessa confirmada em Abacos',
  },
  COULD_NOT_FIND_ANY_WORKING_STORE_FOR_ORDER: {
    value: 'Nenhuma loja disponível para atendimento',
  },
  FAILED: {
    value: 'Falha na captura do pagamento',
  },
  FAILED_TO_CONTACT_CUSTOMER: {
    value: 'Falha ao Contatar Cliente',
  },
  FAILED_TO_CONTACT_CUSTOMER_BY_AREZZOCO: {
    value: 'Falha ao Contatar Cliente',
  },
  LAST_STEP_REACHED_WITH_THE_ORDER_BEING_HANDLED: {
    value: 'Pedido não atendido pelas lojas, aguardando ação',
  },
  NO_STEPS_CONFIGURED_FOR_THE_ORDER: {
    value: 'Nenhum "step" configurado para o pedido',
  },
  NO_STORES_AVAILABLE: {
    value: 'Nenhuma loja disponível para o pedido',
  },
  ORDER_WAS_NOT_BEING_ABLE_TO_BE_DELIVERED: {
    value: 'Pedido não pode ser enviado',
  },
  PAYMENT_HAS_BEEN_CAPTURED: {
    value: 'Pagamento capturado',
  },
  PAYMENT_HAS_FAILED: {
    value: 'Falha na captura do pagamento',
  },
  PAYMENT_TRANSACTION_CREATED: {
    value: 'Transação do pagamento foi criada',
  },
  PAYMENT_TRANSACTION_TRANSFER_ERROR: {
    value: 'Erro na transferência da transação do pagamento',
  },
  PLACE_ORDER_ABACOS: {
    value: 'Remessa colocada em Abacos',
  },
  PROCESSED_BY_JOB: {
    value: 'Processado pelo job',
  },
  REFUND_PAYMENT_TRANSACTION_ERROR: {
    value: 'Erro na transferência de estorno',
  },
  SHIPPING_PROBLEM: {
    value: 'Pedido com Problema',
  },
  SHIPPING_PROBLEM_ANALYZING: {
    value: 'Problema em análise',
  },
  STEP_CHANGE: {
    value: 'Pedido aberto para o step: [observation]',
  },
  UNRESERVED_BY_STORE: {
    value: 'Pedido liberado pela loja: [posName], [posDisplayName]',
  },
  UNSTUCK_BY_ADMIN: {
    value: 'Baixado manualmente por [employeeName]: [observation]',
  },
  CALCULATED_STORES: {
    value: 'Identificação das lojas disponíveis para atendimento',
  },
  TMS_6_75: {
    value: 'Emitida a etiqueta pela transportadora',
  },
  TMS_7_78_0: {
    value: 'Entrega cancelada',
  },
  TMS_7_78: {
    value: 'Entrega cancelada',
  },
  TMS_16_6: {
    value: 'Em rota de entrega',
  },
  TMS_12_3: {
    value: 'Pedido em trânsito',
  },
  TMS_1_67: {
    value: 'Pedido registrado no TMS',
  },
  TMS_9_69: {
    value: 'Pedido sinalizado para despacho no TMS',
  },
  TMS_10_48_85: {
    value: 'Análise fiscal - Apreensão fiscal da mercadoria',
  },
  TMS_10_48_83: {
    value: 'Análise fiscal - Mercadoria em poder da SUFRAMA para internação',
  },
  TMS_10_48_42: {
    value: 'Análise fiscal - Nota fiscal com produtos de setores diferentes',
  },
  TMS_10_48_26: {
    value: 'Análise fiscal - Nota fiscal retida pela fiscalização',
  },
  TMS_10_48_30: {
    value:
      'Análise fiscal - Problema com a documentação (Nota fiscal e/ou CTRC)',
  },
  TMS_10_48_92: {
    value: 'Análise fiscal - Problemas fiscais',
  },
  TMS_10_48_69: {
    value: 'Análise fiscal - Substituição tributária',
  },
  TMS_10_47_9: {
    value: 'Carga errada - Mercadoria em desacordo com o pedido compra',
  },
  TMS_10_47_18: {
    value: 'Carga errada - Mercadorias trocadas',
  },
  TMS_10_47_41: {
    value: 'Carga errada - Pedido de compra incompleto',
  },
  TMS_10_55_35: {
    value: 'Carga incompleta - Quantidade de produto em desacordo NF/Pedido',
  },
  TMS_10_52_97: {
    value:
      'Carga recusada pela transportadora - Carga com dimensão superior ao suportado',
  },
  TMS_10_52_86: {
    value: 'Carga recusada pela transportadora - Excesso de carga/peso',
  },
  'TMS_10_25_AUSENTE 1': {
    value: 'Destinatário ausente',
  },
  'TMS_10_25_AUSENTE 3': {
    value: 'Destinatário ausente',
  },
  TMS_10_25_46: {
    value: 'Destinatário ausente',
  },
  'TMS_10_26_DESTINATARIO DESCONHECIDO': {
    value:
      'Destinatário ausente - Identificação do cliente não informada ou insuficiente',
  },
  TMS_10_27_45: {
    value: 'Destinatário ausente',
  },
  TMS_13_27_100: {
    value: 'Destinatário ausente',
  },
  'TMS_10_37_ENDERECO INSUFICIENTE': {
    value: 'Endereço não localizado ou inválido',
  },
  TMS_10_38_74: {
    value:
      'Destinatário ausente - Funcionário não autorizado a receber mercadorias',
  },
  TMS_10_36_63: {
    value:
      'Destinatário ausente - Identificação do cliente não informada ou insuficiente',
  },
  TMS_10_36_64: {
    value:
      'Destinatário ausente - Identificação do cliente não informada ou insuficiente',
  },
  TMS_10_33_77: {
    value: 'Destinatário mudou de endereço',
  },
  'TMS_10_371_CONTATE SEU FORNECEDOR(-65)': {
    value: 'Pedido em busca interna pela transportadora - Possível Extravio',
  },
  TMS_16_59_31: {
    value: 'Em rota de entrega',
  },
  TMS_16_6_3: {
    value: 'Em rota de entrega',
  },
  TMS_12_59_31: {
    value: 'Em rota de entrega',
  },
  TMS_12_13_67: {
    value: 'Emissão dos documentos de transportes',
  },
  'TMS_10_39_ENDERECO NAO LOCALIZADO': {
    value: 'Endereço não localizado ou inválido',
  },
  'TMS_10_39_NUMERO NAO LOCALIZADO': {
    value: 'Endereço não localizado ou inválido',
  },
  TMS_10_39_102: {
    value: 'Endereço não localizado ou inválido',
  },
  TMS_10_39_6: {
    value: 'Endereço não localizado ou inválido',
  },
  TMS_10_39_60: {
    value: 'Endereço não localizado ou inválido',
  },
  TMS_10_39_06: {
    value: 'Endereço não localizado ou inválido',
  },
  TMS_12_20_91: {
    value: 'Entrega agendada',
  },
  TMS_10_60_68: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_1: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_104: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_105: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_2: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_24: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_4: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_68: {
    value: 'Entrega realizada no destino',
  },
  TMS_10_43_21: {
    value: 'Estabelecimento fechado',
  },
  TMS_10_43_34: {
    value: 'Estabelecimento fechado',
  },
  TMS_10_43_47: {
    value: 'Estabelecimento fechado',
  },
  TMS_10_43_87: {
    value: 'Estabelecimento fechado',
  },
  TMS_10_31_44: {
    value: 'Falha na entrega - Dificuldade de acesso ao endereço',
  },
  TMS_10_31_76: {
    value: 'Falha na entrega - Dificuldade de acesso ao endereço',
  },
  TMS_10_32_43: {
    value: 'Falha na entrega - Feriado local/nacional',
  },
  TMS_10_34_20: {
    value:
      'Falha na entrega - Horário/falta de tempo hábil para chegar ao destino',
  },
  TMS_10_1_99: {
    value: 'Pedido não coletado - Permanece na origem',
  },
  'TMS_10_1_IMPOSSIBILIDADE ENTREGA': {
    value: 'Falha na entrega - motivo não especificado',
  },
  TMS_10_22_103: {
    value: 'Falha na entrega - Pedido na transportadora',
  },
  TMS_10_22_29: {
    value: 'Falha na entrega - Pedido na transportadora',
  },
  TMS_10_51_58: {
    value: 'Falha na entrega - Problema com o veículo de entrega',
  },
  TMS_10_58_50: {
    value: 'Greve geral',
  },
  TMS_10_119_79: {
    value: 'Pedido avariado',
  },
  TMS_10_62_38: {
    value: 'Pedido avariado',
  },
  TMS_13_62_38: {
    value: 'Pedido avariado',
  },
  TMS_13_62_78: {
    value: 'Pedido avariado',
  },
  TMS_13_62_79: {
    value: 'Pedido avariado',
  },
  TMS_12_17_98: {
    value: 'Pedido chegou na cidade ou filial de destino',
  },
  TMS_12_10_0: {
    value: 'Pedido coletado - transporte iniciado',
  },
  TMS_13_63_25: {
    value: 'Pedido devolvido para a origem',
  },
  TMS_10_12_84: {
    value: 'Pedido em conferência no transportador',
  },
  TMS_10_28_16: {
    value: 'Pedido em conferência no transportador',
  },
  'TMS_10_40_SOLICITACAO ENTREGA FUTURA': {
    value: 'Destinatário solicitou entrega futura ou outro dia',
  },
  TMS_10_40_5: {
    value: 'Pedido em conferência no transportador',
  },
  TMS_10_41_51: {
    value: 'Pedido em conferência no transportador',
  },
  TMS_10_42_59: {
    value: 'Pedido em conferência no transportador',
  },
  TMS_10_42_61: {
    value: 'Pedido em conferência no transportador',
  },
  TMS_10_42_73: {
    value: 'Pedido em conferência no transportador',
  },
  'TMS_10_420_TRAFEGO INTERROMPIDO': {
    value: 'Análise fiscal - Parado para fiscalização',
  },
  TMS_10_420_TRAVADO: {
    value: 'Análise fiscal - Problemas fiscais',
  },
  TMS_10_43_FECHADO: {
    value: 'Estabelecimento fechado',
  },
  'TMS_12_19_DEVOLUCAO POR INSTRUCAO REMETENTE': {
    value: 'Pedido em devolução - Recusado pelo destinatário',
  },
  'TMS_12_19_EM DEVOLUCAO': {
    value: 'Pedido em devolução',
  },
  'TMS_12_19_LISTA DEVOLUCAO': {
    value: 'Pedido em devolução',
  },
  TMS_12_19_66: {
    value: 'Pedido em devolução',
  },
  TMS_12_15_33: {
    value: 'Pedido em transferência entre as filiais do transportador',
  },
  TMS_12_15_95: {
    value: 'Pedido em transferência entre as filiais do transportador',
  },
  TMS_10_121_81: {
    value: 'Pedido extraviado',
  },
  TMS_10_64_23: {
    value: 'Pedido extraviado',
  },
  TMS_10_64_37: {
    value: 'Pedido extraviado',
  },
  TMS_13_64_23: {
    value: 'Pedido extraviado',
  },
  TMS_13_64_37: {
    value: 'Pedido extraviado',
  },
  TMS_13_64_80: {
    value: 'Pedido extraviado',
  },
  TMS_13_64_81: {
    value: 'Pedido extraviado',
  },
  TMS_10_24_10: {
    value: 'Pedido recusado pelo destinatário',
  },
  TMS_10_24_101: {
    value: 'Pedido recusado pelo destinatário',
  },
  TMS_10_24_62: {
    value: 'Pedido recusado pelo destinatário',
  },
  TMS_10_24_71: {
    value: 'Pedido recusado pelo destinatário',
  },
  TMS_10_24_72: {
    value: 'Pedido recusado pelo destinatário',
  },
  TMS_10_24_94: {
    value: 'Pedido recusado pelo destinatário',
  },
  TMS_10_24_3: {
    value: 'Pedido recusado pelo destinatário - Compra não reconhecida',
  },
  TMS_10_24_4: {
    value: 'Pedido recusado pelo destinatário - Compra não reconhecida',
  },
  'TMS_10_51_NAO ENTROU NA UNIDADE': {
    value: 'Pedido não chegou na filial da transportadora',
  },
  'TMS_10_51_TERMO DE IRREGULARIDADE': {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_56: {
    value: 'Pedido recusado pelo destinatário - Compra não reconhecida',
  },
  TMS_10_24_11: {
    value: 'Pedido recusado pelo destinatário - Integridade da embalagem',
  },
  TMS_10_24_8: {
    value:
      'Pedido recusado pelo destinatário - Produto em desacordo com a compra',
  },
  TMS_10_16_52: {
    value: 'Pedido redespachado',
  },
  TMS_13_65_27: {
    value: 'Pedido roubado',
  },
  TMS_13_65_14: {
    value: 'Pedido sinistrado',
  },
  TMS_13_65_15: {
    value: 'Pedido sinistrado',
  },
  TMS_10_51_53: {
    value: 'Pedido não coletado - Permanece na origem',
  },
  TMS_10_51_54: {
    value: 'Problema ao coletar o pedido - Permanece na origem',
  },
  TMS_10_51_12: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_17: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_32: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_36: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_39: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_40: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_48: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_49: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_55: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_70: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_75: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_82: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_89: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_90: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_51_96: {
    value: 'Problema operacional no transporte do pedido',
  },
  TMS_10_18_19: {
    value: 'Solicitada a reentrega do pedido',
  },
  TMS_10_18_22: {
    value: 'Solicitada a reentrega do pedido',
  },
  TMS_10_46_28: {
    value: 'Transportador aguardando instrução',
  },
  TMS_10_46_65: {
    value: 'Transportador aguardando instrução',
  },
  TMS_10_46_7: {
    value: 'Transportador aguardando instrução',
  },
  TMS_10_46_88: {
    value: 'Transportador aguardando instrução',
  },
  TMS_10_46_93: {
    value: 'Transportador aguardando instrução',
  },
  TMS_10_23_13: {
    value: 'Transportadora não atende a cidade de destino',
  },
  TMS_10_23_57: {
    value: 'Transportadora não atende a cidade de destino',
  },
  TMS_12_10_00: {
    value: 'Pedido coletado - transporte iniciado',
  },
  TMS_12_10_10: {
    value: 'Pedido coletado - transporte iniciado',
  },
  TMS_12_19_14: {
    value: 'Pedido em devolução',
  },
  TMS_12_9_100: {
    value: 'Coleta agendada',
  },
  TMS_12_9_21: {
    value: 'Coleta agendada',
  },
  TMS_13_5: {
    value: 'Falha na entrega - motivo não especificado',
  },
  TMS_13_5_44: {
    value: 'Falha na entrega - Sem nova tentativa',
  },
  TMS_13_63_40: {
    value: 'Pedido devolvido para a origem',
  },
  TMS_14_4: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_35: {
    value: 'Entrega realizada no destino',
  },
  TMS_16_480_31: {
    value: 'Em rota de entrega',
  },
  TMS_14_60_ENTREGUE: {
    value: 'Entrega realizada no destino',
  },
  TMS_14_60_01: {
    value: 'Entrega realizada no destino',
  },
  'TMS_16_59_EM ROTA': {
    value: 'Em rota de entrega',
  },
  TMS_12_11_ENTRADA: {
    value: 'Pedido chegou na filial da transportadora',
  },
  TMS_12_12_UNITIZADO: {
    value: 'Pedido em processamento na filial da transportadora',
  },
  'TMS_12_15_TRANSFERIDO A UNIDADE': {
    value: 'Em transferência',
  },
  TMS_12_13_EMISSAO: {
    value: 'Emissão dos documentos de transportes',
  },
  TMS_12_15_TRANSFERENCIA: {
    value: 'Pedido em transferência entre as filiais do transportador',
  },
  'TMS_12_15_TRANSFERIDO PARA UNIDADE': {
    value: 'Pedido em transferência entre as filiais do transportador',
  },
};
